import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import client from '../api/client';

export async function registerPushNotifications() {
  console.log('[push] registerPushNotifications called, native:', Capacitor.isNativePlatform());
  if (!Capacitor.isNativePlatform()) return;

  try {
    const permStatus = await PushNotifications.checkPermissions();
    console.log('[push] Permission status:', JSON.stringify(permStatus));
    let finalStatus = permStatus.receive;

    if (finalStatus === 'prompt') {
      const result = await PushNotifications.requestPermissions();
      finalStatus = result.receive;
    }

    if (finalStatus !== 'granted') {
      console.log('[push] Permission not granted:', finalStatus);
      return;
    }

    PushNotifications.addListener('registration', async ({ value: token }) => {
      try {
        const platform = Capacitor.getPlatform();
        await client.post('/push/register', { token, platform });
        console.log('[push] Token registered');
      } catch (err) {
        console.error('[push] Token registration failed:', err.message);
      }
    });

    PushNotifications.addListener('registrationError', (err) => {
      console.error('[push] Registration error:', err.error);
    });

    PushNotifications.addListener('pushNotificationReceived', (notification) => {
      console.log('[push] Received foreground:', notification.title);
    });

    PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
      const data = action.notification.data;
      try {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        const role = user.role || 'student';
        if (data?.type === 'announcement') {
          const routes = { admin: '/admin/announcements', teacher: '/teacher/alerts', parent: '/parent', student: '/student/announcements' };
          window.location.hash = '#' + (routes[role] || '/student/announcements');
        } else if (data?.type === 'fee') {
          const routes = { admin: '/admin/fees', parent: '/parent/fees', teacher: '/teacher', student: '/student' };
          window.location.hash = '#' + (routes[role] || '/student');
        }
      } catch {
        window.location.hash = '#/parent';
      }
    });

    await PushNotifications.register();
  } catch (err) {
    console.error('[push] ERROR:', err && (err.message || JSON.stringify(err)));
  }
}

export async function unregisterPushNotifications() {
  if (!Capacitor.isNativePlatform()) return;
  try {
    await PushNotifications.removeAllListeners();
    await client.delete('/push/unregister');
  } catch { /* ignore */ }
}
